var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97594 9C3.59507 9 2.00782 10.5556 1.51181 11.3333C0.0237595 13.2 2.13182 13.6667 3.37186 13.6667H7.836C9.20004 13.6667 11.7049 13.2 10.8121 11.3333C9.91926 9.46667 7.21598 9 5.97594 9Z",
    stroke: "#96A8BA",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 3,
    stroke: "#96A8BA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.f81af87e5641fe8bd5bf6f1c598fd0d5.svg";
export { ForwardRef as ReactComponent };